import './EllipsisLoader.css';

const EllipsisLoader = () => {
  return (
    <span className="lds-ellipsis">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </span>
  );
};

export default EllipsisLoader;
